import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"building-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6.49991 4C8.99995 4.00003 9.16656 6.66667 8.99991 8L9.00049 11H21.0005V21H4.00044V8C3.83378 6.66667 3.99981 4 6.49991 4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M13 16V21H17V16H13Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M13 16H17V21H13z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2.5 8H3.99991M3.99991 8H8.99991M3.99991 8V21H8.99991M3.99991 8C3.83324 6.66667 3.99981 4 6.49991 4M8.99991 8H10.5M8.99991 8V21M8.99991 8C9.16657 6.66667 9 4 6.49991 4M8.99991 21H21V11H9L8.99991 21ZM6.49991 4V2.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Building1 = Vue.extend<IconProps>({
  name: 'Building1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'building-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Building1;
